import React, { useState } from 'react';

const SliderInput = ({ name, sliderValues, onChange, onRelease }) => {
  const [hasValueChanged, setHasValueChanged] = useState(false);

  const handleChange = (e) => {
    const value = e.target.value;
    let limit = sliderValues.limit;

    if(name === 'to'){
      limit = sliderValues.max;
    }

    if (
      !limit ||
      (name === 'from' && value >= limit) ||
      (name === 'to' && value > limit)
    )
      return;

    setHasValueChanged(true);

    onChange && onChange(e, hasValueChanged);
  };

  const handleMU = (e) => hasValueChanged && onRelease && onRelease(e);

  return (
    <input
      name={name}
      className={`filter-slider__${name}`}
      type="range"
      value={sliderValues.value}
      min={sliderValues.min}
      max={sliderValues.max}
      onChange={handleChange}
      onMouseUp={handleMU}
      onTouchEnd={handleMU}
    />
  );
};
export default SliderInput;
